import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { Moment } from 'moment/moment';
import { ITask } from '@nimbus-assistant/models/task.model';
import { getModalityIcon } from '@nimbus-assistant/helpers/task-priority.helpers';
import { ICONS, Icon } from '@nimbus-library/features/shared/resources/icons';
import { IconWeight } from '@nimbus-library/features/shared/directives/icon-weight.enum';
import { TranslationKeys } from '@nimbus-library/features/localization/models/enums/translation-keys.enum';
import { BackgroundTaskFactory } from '@nimbus-library/features/background-task/background-task.factory';
import { SharedUIModule } from '@nimbus-library/features/shared/shared.ui.module';

@Component({
  standalone: true,
  selector: 'app-footer-info',
  templateUrl: './footer-info.component.html',
  styleUrls: ['./footer-info.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, TranslateModule, SharedUIModule],
})
export class FooterInfoComponent implements OnInit {
  @Input({ required: true }) public task: ITask;
  @Input() public statusText: string;
  @Input() public showTime = true;

  public readonly ICONS = ICONS;
  public readonly IconWeight = IconWeight;
  public readonly TranslationKeys = TranslationKeys;
  public currentMoment$: Observable<Moment>;

  public constructor(private readonly backgroundTaskFactory: BackgroundTaskFactory) {}

  public ngOnInit(): void {
    this.currentMoment$ = this.backgroundTaskFactory.getServerWatches();
  }

  public get modalityIcon(): Icon {
    return getModalityIcon(this.task);
  }
}
